import { builderLightText } from '@/legacy/blocks/utils'

import type { TypographyColorModifierWithPrimary } from '../types'

export const textColorModifierWithPrimary = (
  colorModifier?: TypographyColorModifierWithPrimary,
) => {
  if (colorModifier === 'primary') {
    return { color: colorModifier }
  }
  const lightText = builderLightText(colorModifier)
  return { light: lightText as 'solid' }
}
